var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_\\uCC44\\uD305",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_35",
    "data-name": "\\uC0AC\\uAC01\\uD615 35",
    width: 18,
    height: 18,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_71",
    "data-name": "\\uADF8\\uB8F9 71",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_38",
    "data-name": "\\uD328\\uC2A4 38",
    d: "M5.937,11.878a6.477,6.477,0,0,1-2.86-.658,5.67,5.67,0,0,1-2.618.658.206.206,0,0,1-.192-.125.212.212,0,0,1,.039-.228A7.463,7.463,0,0,0,1.389,9.947,4.326,4.326,0,0,1,.25,7.066C.25,4.408,2.8,2.253,5.937,2.253s5.688,2.155,5.688,4.813-2.546,4.812-5.688,4.812M17.692,15.9a.213.213,0,0,1,.039.229.2.2,0,0,1-.192.126,5.632,5.632,0,0,1-2.5-.6,5.591,5.591,0,0,1-2.539.6A5.16,5.16,0,0,1,7.411,12.6,5.94,5.94,0,0,0,12.5,7.066c0-.148-.014-.293-.026-.438H12.5a5.047,5.047,0,0,1,5.25,4.813,4.544,4.544,0,0,1-1.1,2.944A7.5,7.5,0,0,0,17.692,15.9",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon_채팅.b4b500a06b058bbdb151b4cd55c3c21e.svg";
export { ForwardRef as ReactComponent };